import React from 'react';
import { Block, CheckIcon, DefaultText, FlexRow, RightIcon } from '@guryou/html-components';
import { makeStyles } from '@material-ui/core/styles';
import { dealTokens } from 'components/shared';

const useStyles = makeStyles({
  box: ({ isFinished }) => ({
    transition: `background ${dealTokens.motion.fast}`,
    '&:hover': {
      backgroundColor: isFinished ? dealTokens.color.successSoft : dealTokens.color.canvas,
    },
    cursor: 'pointer',
  }),
  disabled: {
    backgroundColor: dealTokens.color.canvas,
    color: dealTokens.color.textMuted,
    cursor: 'default !important',
  },
});

const isFinished = (type, finished) => {
  if (type === 'service' && finished?.service) {
    return true;
  }
  if (type === 'course' && finished?.course) {
    return true;
  }
  if (type === 'event' && finished?.event) {
    return true;
  }
};

const ServiceBlock = ({ title, disabled = false, step = 4, setActiveStep, finished, type }) => {
  const classes = useStyles({ isFinished: isFinished(type, finished) });
  const handleClick = () => {
    if (!disabled) {
      setActiveStep(step, type);
    }
  };

  return (
    <Block
      onClick={handleClick}
      className={disabled ? classes.disabled : classes.box}
      xs={12}
      margin={2}
      marginLeft={0.5}
      padding={4}
      border={`1px solid ${isFinished(type, finished) ? dealTokens.color.success : dealTokens.color.border}`}
      borderRadius={`${dealTokens.radius.md}px`}
    >
      <FlexRow margin={0} padding={0}>
        <Block xs={10}>
          <DefaultText
            fontWeight={800}
            color={disabled ? dealTokens.color.textMuted : isFinished(type, finished) ? dealTokens.color.success : undefined}
          >
            {title}
          </DefaultText>
        </Block>
        <Block xs={2} display="flex" flexDirection="row" alignItems="center" justifyContent="end">
          {isFinished(type, finished) ? <CheckIcon fontSize="medium" htmlColor={dealTokens.color.success} /> : <RightIcon fontSize="medium" />}
        </Block>
      </FlexRow>
    </Block>
  );
};

export default ServiceBlock;
